import React from 'react';

import { InputAdornment } from '@mui/material';
import { TextField } from '@provider-portal/design-common/kalep/components/TextField/TextField';

import { Search } from '@bolteu/kalep-react-icons';
import { useIntl } from 'react-intl';

export type StoreSelectorSearchStrings = Record<'searchPlaceholder', string>;
export interface StoreSelectorSearchProps {
  onSearch: (search: string) => void;
}

export function StoreSelectorSearch({ onSearch }: StoreSelectorSearchProps) {
  const intl = useIntl();
  const searchPlaceholder = intl.formatMessage({ id: 'venueSelector.search.placeholder' });

  const handleOnChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onSearch(event.target.value);
    },
    [onSearch],
  );

  return (
    <TextField
      sx={{ mb: '12px' }}
      placeholder={searchPlaceholder}
      size="medium"
      fullWidth
      onChange={handleOnChange}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
        },
      }}
    />
  );
}
